import {Component, OnInit} from "@angular/core";
import {Subject} from "rxjs";


@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  private destroyed$: Subject<void> = new Subject<void>();

  ngOnInit() {

  }

}
